enum FILE_ACTION_TYPES {
  DOWNLOAD_FILE = 'DOWNLOAD_FILE',
  BUDDHIMED_FILE_UPLOAD = 'BUDDHIMED_FILE_UPLOAD',
  VERIFY_MOBILE_NUMBER = 'VERIFY_MOBILE_NUMBER',
  VERIFY_AADHAR_NUMBER = 'VERIFY_AADHAR_NUMBER',
  VERIFY_MOBILE_OTP = 'VERIFY_MOBILE_OTP',
  VERIFY_AADHAAR_OTP = 'VERIFY_AADHAAR_OTP',
  UPLOAD_DOC = 'UPLOAD_DOC',
  DOWNLOAD_ALL_FILES = 'DOWNLOAD_ALL_FILES',
  PREVIEW_FILE = 'PREVIEW_FILE',
  HIS_FILE_DOWNLOAD = 'HIS_FILE_DOWNLOAD',
}

export default FILE_ACTION_TYPES;
